module.exports = __webpack_public_path__ + "static/media/market-newbie.f5a818ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/market-newbie.jpg
// module id = 2631
// module chunks = 0